<template>
    <div class="row">
        <div class="col-12">
            <div v-if="store.pending" class="row mb-3">
                <div class="pr--preloader __animated">
                    <div class="--icon" />
                    <div class="--text">
                        Идет загрузка ...
                    </div>
                </div>
            </div>
            <div v-if="!store.pending && store.data.length" class="row mb-3">
                <FrontendArticleCardLeft
                    v-for="(article, key) in store.data"
                    :key="key"
                    :article="article"
                />
            </div>
            <div v-if="!store.pending && !store.data.length" class="row mb-3">
                <div class="col-12 text-center">
                    Список пуст
                </div>
            </div>
            <div v-if="store.pagination !== null && !store.pending" class="row mb-3">
                <div class="col-12">
                    <PaginationRow :pagination="store.pagination" :on-change="onChangePage" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { defineComponent } from 'vue';
import PaginationRow from '@/components/Base/Pagination/PaginationRow.vue';
import FrontendArticleCardLeft from '@/components/Frontend/Article/FrontendArticleCardLeft.vue';

export default defineComponent({
    name: 'FrontendArticleCardList',
    components: {
        PaginationRow,
        FrontendArticleCardLeft,
    },
    props: {
        store: {
            type: [Object],
            default: () => {
                return {
                    data: [],
                    pending: false,
                    pagination: null,
                };
            },
        },
        onChangePage: {
            type: [Function],
            default: () => {},
        }
    },
});
</script>
